/* Custom Theme Scripts go in -> AquaTechTheme-foot.js */
"use strict";

var CustLoadScript = function(url, callback) {
    // console.log('CustLoadScript: ' + url);
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState){
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        script.onload = function() {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};

var AquaTechTheme = (function (my) {
    my.VERSION = '23.9.11.1';
    my.DEBUG = false;
    my.$ = null;
    my.modules = {};
    my.viewport = null;
    my.heightFitGroups = [];

    my.dlog = function(logmsg) {
        if (AquaTechTheme.DEBUG) {
            console.log(`DEBUG: ${logmsg}`);
        }
    };

    my.registerModule = function(name, url, callback) {
        my.modules[name] = {
            url: url,
            callback: callback
        };
    };

    my.loadModules = function() {
        for (var module in my.modules) {
            if (my.modules.hasOwnProperty(module)) {
                var theModule = my.modules[module];
                if (theModule.url) {
                  CustLoadScript(theModule.url, theModule.callback);
                } else {
                  theModule.callback();
                }
                my.dlog(`Module loaded: ${module}`);
            }
        }
    }

    my.initHead = function() {
        // HTML5BP: Avoid `console` errors in browsers that lack a console.
        (function() {
            var noop = function () {};
            var methods = [
                'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
                'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
                'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
                'timeStamp', 'trace', 'warn'
            ];
            var length = methods.length;
            var console = (window.console = window.console || {});
            while (length--) {
                var method = methods[length];
                if (!console[method]) {
                    console[method] = noop;
                }
            }
        }());

        my.dlog(`AquaTechTheme v${my.VERSION} DEBUG enabled`);
    };

    my.getViewport = function() {
        my.viewport = {
            width : window.innerHeight,
            height : window.innerWidth
        };

        return my.viewport;
    };

    my.callFunc = function(functionName, args) {
        var fn = window[functionName];
        if (typeof fn === "function") {
            fn.apply(null, args);
        }
    };

    my.getUrlDomain = function(url) {
        url = typeof url !== "undefined" ? url : window.location.href;

        var domain = (url.indexOf("://") > -1) ? url.split('/')[2] : url.split('/')[0];
        domain = domain.split(':')[0];
        domain = domain.replace('www.', '');

        return domain;
    };

    my.getUrlSegments = function(url) {
        var pathname = typeof url !== "undefined" ?
            url.substr(url.indexOf('/', 7) + 1) :
            window.location.pathname;
        var segs = pathname.split("/");
        segs.shift();

        return segs;
    };

    my.getUrlParts = function() {
        var parts = {
          'url': window.location + '',
          'domain': window.location.protocol + '//' + window.location.host,
          'path': window.location.pathname,
          'args': ''
        };
        var split = parts.url.split('?');
        if (split.length == 2) {
          parts.args = split[1];
        }

        return parts;
    };
  
    my.getUrlParameter = function(sParam, url) {
        var matches = [];

        var search = typeof url !== "undefined" ?
            decodeURIComponent(url.substr(url.indexOf('?') + 1)) :
            decodeURIComponent(window.location.search.substring(1));
        var sURLVariables = search.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                matches.push(sParameterName[1] === undefined ? true : sParameterName[1]);
            }
        }

        return matches.length == 0 ? null : (matches.length == 1 ? matches.pop() : matches);
    };

    my.getUrlParam = function(sParam, url) { return my.getUrlParameter(sParam, url); }

    my.removeUrlParameter = function(key, url) {
        url = typeof url !== "undefined" ? url : window.location.href;
        var rtn = url.split("?")[0];
        var queryString = (url.indexOf("?") !== -1) ? url.split("?")[1] : "";
        if (queryString !== "") {
            var params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                var param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = `${rtn}?${params_arr.join("&")}`;
        }
        return rtn;
    };

    my.removeParam = function(key, url) { return my.removeUrlParameter(key, url); }

    my.applyUrlParameter = function(key, val, url) {
        url = typeof url !== "undefined" ? url : window.location.href;
        url = my.removeParam(key, url);
        return url += (url.match(/\?/) ? '&' : '?') + key + '=' + val;
    };

    my.applyParam = function(key, val, url) { return my.applyUrlParameter(key, val, url) }

    my.isCrawlerBot = function() {
        var botPattern = "(googlebot\/|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|Google-Site-Verification|Storebot-Google|AdsBot-Google-Mobile|APIs-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)";
        var re = new RegExp(botPattern, 'i');
        var userAgent = navigator.userAgent;
        if (re.test(userAgent)) {
            return true;
        } else{
            return false;
        }
    };
  
    my.slugify = function(str, separator) {
        separator = typeof(separator) === 'undefined' ? '-' : separator;

        str = str.trim();
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
        var to = "aaaaaaeeeeiiiioooouuuunc------";

        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
        }

        return str
            .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-") // collapse dashes
            .replace(/^-+/, "") // trim - from start of text
            .replace(/-+$/, "") // trim - from end of text
            .replace(/-/g, separator);
    };

    my.addHeightFitGroup = function(groupClass) {
        var selector = (groupClass.charAt(0) == '.' || groupClass.charAt(0) == '#') ? groupClass : '.' + groupClass;
        my.heightFitGroups.push(selector);
    };

    my.removeHeightFitGroup = function(groupClass) {
        var selector = (groupClass.charAt(0) == '.' || groupClass.charAt(0) == '#') ? groupClass : '.' + groupClass;
        var index = my.heightFitGroups.indexOf(selector);
        if (index !== -1)  my.heightFitGroups.splice(index, 1);
    };

    my.updateHeightFitGroups = function() {
        var self = this;
        var $ = self.$;

        var tallestFunc = (el, tallest) => {
            var $el = $(el);
            $el.css('height', 'auto');
            var height = parseInt($el.outerHeight());
            tallest = height > tallest ? height : tallest;

            return tallest;
        };

        for (var gi = 0, len = my.heightFitGroups.length; gi < len; gi++) {
            var selector = my.heightFitGroups[gi];
            var $elements = $(selector);

            var tallest = 0;
            $elements.each((i, el) => {
                tallest = tallestFunc(el, tallest);
            });

            $elements.css('height', tallest + 'px');
        }
    };

    my.isOnScreen = function(elem) {
      if( elem.length == 0 ) {
          return;
      }
      var $window = jQuery(window)
      var viewport_top = $window.scrollTop()
      var viewport_height = $window.height()
      var viewport_bottom = viewport_top + viewport_height
      var $elem = jQuery(elem)
      var top = $elem.offset().top
      var height = $elem.height()
      var bottom = top + height

      return (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom);
    };

    return my;
}(AquaTechTheme || {}));

AquaTechTheme.initHead();
